<template>
    <card :class="{'atrasado' : emprestimo.atrasado }">
        <div class='row'>
            <div class='col-md-9 col-12'>
                <strong>Livro: {{emprestimo.obra.titulo}}</strong>
                <div>
                    <small>{{emprestimo.obra.subtitulo}}</small>
                </div>
                <div v-if="emprestimo.nao_membro">
                  <strong>Observações: </strong>
                  <span >{{emprestimo.observacao}}</span>
                </div>
                <div>
                    <strong>Emprestado para: </strong>
                    <span v-if='emprestimo.membro'>{{emprestimo.membro.full_name}}</span>
                    <span v-else>Membro excluído</span> 
                </div>
                <template v-if='!!emprestimo.usuario'>
                    <atendente v-if='emprestimo.usuario' :mostrar="!!emprestimo.usuario" :atendente="emprestimo.usuario.name" />
                    <span v-else>Membro excluído</span>
                </template>
                <div>
                  <strong>Data do Empréstimo: </strong>
                  <span>{{ formatDate(emprestimo.data_emprestimo) }}</span>
                </div>
                <div>
                    <strong>Devolução: </strong>
                    <span>{{ emprestimo.data_limite | formatDate}}</span>
                </div>
                <div>
                    <strong>Renovações: </strong>
                    <span class="badge badge-pill badge-info">{{emprestimo.renovacoes}}</span>
                </div>
                <div>
                  <span v-if='emprestimo.nao_membro' class="badge badge-warning"> Não Membro </span>
                  <span v-if='emprestimo.perdido' class="badge badge-danger"> Perdido </span>
                </div>
                <span class="badge badge-warning" v-if="emprestimo.reservas && emprestimo.reservas.length">Reservado</span>
            </div>
            <div class='col-md-3 col-12'>
              <div>
                <button v-if='!emprestimo.devolvido' class='btn btn-warning btn-block' @click='devolver(emprestimo)'>Devolver</button>
                <button @click='desdevolver(emprestimo)' v-else class='btn btn-success btn-block' >
                  <span>Devolvido</span>
                  <div><small>{{emprestimo.data_devolucao | formatDate}}</small></div>
                </button>
                <button v-if='!emprestimo.devolvido' class='btn btn-info btn-block' @click='renovar(emprestimo)'>Renovar</button>
                <!--<button v-if='!emprestimo.devolvido' :class="{'btn-danger' : !emprestimo.perdido, 'btn-success' : emprestimo.perdido}" class='btn btn-block' @click='perdido(emprestimo)'>
                  <span v-if='!emprestimo.perdido'>Perdido</span>
                  <span v-else>Encontrado</span>
                </button>-->
                <!--<router-link v-if='!emprestimo.devolvido' class='btn btn-block btn-outline-danger' :to="`editEmprestimo/${emprestimo.id}`">Avançado</router-link>-->
                <!--<button v-if='emprestimo.atrasado && !emprestimo.email_enviado' class='btn btn-warning btn-block' @click="email(emprestimo)">Enviar Email</button>-->
              </div>
            </div>
        </div>
        <div>
        </div>
    </card>
</template>

<script>
import Atendente from '../Atendente'

import moment from 'moment'
export default {
  components: {
    Atendente
  },
  props: {
    emprestimo: {
      type: Object,
      required: true
    },
  },
  methods: {
    devolver (emprestimo) {
      this.$emit('devolver', emprestimo)
    },
    desdevolver (emprestimo) {
      this.$emit('desdevolver', emprestimo)
    },
    renovar (emprestimo) {
      this.$emit('renovar', emprestimo)
    },
    perdido (emprestimo) {
      this.$emit('perdido', emprestimo)
    },
    email (emprestimo) {
      this.$emit('email', emprestimo)
    },
    formatDate(data) {
      if (data) {
        return moment(String(data)).format('DD/MM/YYYY [-] HH[h]mm')
      }
    }
  }
}
</script>
